import styled, { css } from "styled-components";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { deviceMax, reducedMotion } from "../../../utils/device";

export const StyledAccordion = styled(Accordion)``;

export const StyledAccordionItem = styled(AccordionItem)(
  ({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.brand.line};

    &:first-child {
      border-top: 1px solid ${theme.colors.brand.line};
    }
  `
);

export const StyledAccordionItemHeading = styled(AccordionItemHeading)`
  margin: 0;
`;

export const StyledAccordionItemButton = styled(AccordionItemButton)`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  gap: 25px;
  justify-content: space-between;
  line-height: 1.5;
  padding: 23px 0;

  @media ${deviceMax.tabletWideMax} {
    font-size: 13px;
  }

  @media ${deviceMax.phoneMax} {
    padding: 22px 0;
  }
`;

export const StyledAccordionItemPanel = styled(AccordionItemPanel)`
  p {
    color: ${({ theme }) => theme.colors.brand.muted};
    font-size: 13px;
    line-height: 1.8;
    margin: 0;
    max-width: 590px;
    padding: 0 30px 23px 0;
  }
`;

interface IStyledIcon {
  isOpen?: boolean;
}

export const StyledIcon = styled.span<IStyledIcon>(
  ({ isOpen }) => css`
    align-items: center;
    display: flex;
    flex: none;

    svg {
      height: 18px;
      transform: ${isOpen ? "rotate(45deg)" : "rotate(0)"};
      transition: transform 0.2s ease-in-out;
      width: 18px;
    }

    @media ${reducedMotion} {
      svg {
        transition: none;
      }
    }
  `
);
